import { appEventsAtom, appPointsAtom, appSignatureAtom, Events } from '@/state/app';
import { defaultStanding, getStanding } from '@/utils/http/get-standing';
import { useEffect } from 'react';
import { useRecoilState, useRecoilValue } from 'recoil';
import { useLocalStorage } from 'react-use';
import { LocalStorageKeys } from '@/constants/local-storage';
import { useWallet } from '@/hooks/wallet';
import { useTranslation } from '@/hooks/support/translate';
import { useEvents } from '@/hooks/events';

export const usePoints = () => {
    const { t } = useTranslation();
    const { pushEvent } = useEvents();
    const { walletState, provider } = useWallet();
    const appEvents = useRecoilValue(appEventsAtom);
    const [state, setState] = useRecoilState(appPointsAtom);
    const [signature, setSignature] = useRecoilState(appSignatureAtom);
    const [signatureCookie, setSignatureCookie] = useLocalStorage(LocalStorageKeys.MISSION_HUB_SIGNATURE, undefined, {
        raw: false,
        serializer: (value: any) => JSON.stringify(value),
        deserializer: (value: any) => JSON.parse(value),
    });

    const refreshPoints = async () => {
        pushEvent(Events.refreshPoints);
    };

    useEffect(() => {
        refreshData();
        if (signatureCookie) {
            setSignature(signatureCookie);
        }
    }, [walletState.selectedAddress, appEvents.refreshPoints]);

    const signup = async () => {
        const signature = await provider.send('personal_sign', [
            // @ts-ignore
            t('modal.pointsSystem.quiz.signMessage'),
            walletState.selectedAddress,
        ]);
        if (signature) {
            // This will actually overwrite the address, but it's a nice trick
            // Annoying those using several wallets as they need to sign every time
            const s = { address: walletState.selectedAddress, signature };
            setSignatureCookie(s);
            // @ts-ignore
            setSignature(s);
        }
    };

    const refreshData: () => Promise<any> = async () => {
        try {
            if (walletState.selectedAddress) {
                setState({ ...state, isLoading: true });
                const standingData = await getStanding(walletState.selectedAddress!);

                // const connect = standingData?.activities?.find((x) => x.id === 'TWITTER-Connect');
                setState((previous) => ({
                    ...previous,
                    isLoading: false,
                    standingData,
                    lastUpdate: new Date(),
                }));
            }
        } catch (e) {
            setState((previous) => ({
                ...previous,
                isLoading: false,
                standingData: defaultStanding,
                lastUpdate: new Date(),
            }));
        }
    };

    return {
        ...state,
        refreshPoints,
        signup,
    };
};
